module.exports = __webpack_public_path__ + "static/media/chevron-right-dark.0533dbc4.svg";